import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import axios from "axios";
import { getConfig } from "../../../../../network/auth";
import { baseUrl } from "../../../../../network/constants/constants";
import AppConstants from "../../../../AppConstants";
import SearchField from "../../../../customComponent/searchField/searchField";
import TableComponent from "../../../../customComponent/table/tableComponent";

const RejectedJob = () => {
  const [rejectJobList, setRejectJobList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const formattedRejectedJob = rejectJobList?.map((rejected) => ({
    ...rejected,
    booked_at: new Date(rejected.booked_at).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }),
  }));

  const filteredRejectedJob = formattedRejectedJob.filter((rejected) =>
    Object.entries(rejected).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.some((item) =>
          item.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      }
  
      return (
        value &&
        value.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
    })
  );

  const displayRejectedJob = searchValue ? filteredRejectedJob : formattedRejectedJob;

  const alertwithIndex = displayRejectedJob.map((alert, index) => ({
    ...alert,
    displayIndex: index + 1,
  }));

  const fetchRejectJob = () => {
    setLoading(true);
    axios
      .get(
        baseUrl + `superadmin/rejected-job-alerts/`,
        config
      )
      .then((response) => {
        setRejectJobList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Customer Cancelled Alert Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRejectJob();
  }, []);

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "ID", width: 90 },
    { field: "customer_name", headerName: "Customer Name", width: 150 },
    { field: "customer_phone", headerName: "Customer Phone", width: 150 },
    { field: "worker_name", headerName: "Worker Name", width: 150 },
    { field: "worker_phone", headerName: "Worker Phone", width: 150 },
    { field: "booking_id", headerName: "Booking Id", width: 100 },
    {
      field: "booked_at",
      headerName: "Booked Date",
      width: 200,
    },
    { field: "booking_address", headerName: "Booking Address", width: 160 },
    { field: "booking_service_name", headerName: "Service Name", width: 150 },
  ];
  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row className="mb-2">
            <Col>
              <SearchField searchValue={searchValue} handleSearchChange={handleSearchChange}/>
            </Col>
          </Row>
          <Row>
            <TableComponent rows={alertwithIndex} columns={columns} />
          </Row>
        </>
      )}
    </>
  );
};

export default RejectedJob;
